import TableVM from '../table-vm';
import GradebookServices from '../services';
export default Kadenze.Util.extendObj(TableVM, function() {
  var self = this;
  self.$el = $('#analytics-tab-content');
  self.averages = ko.observableArray([]);
  self.courseworks = ko.observableArray([]);
  self.coursework_stats = ko.observableArray([]);
  self.coursework_ids = ko.observableArray([]);
  self.analyticsRefreshed = ko.observable(false);

  self.initUI = function() {
    var $dropDowns = self.$el.find('.js-table-dropdown');
    $dropDowns.on('shown.bs.dropdown', function () {
      var $menu = $(this);
      self.updateMenuPosition($menu);
    });
  };

  self.getSheet = function() {
    var url = Kadenze.Routes.course_gradebook_analytics_path(self.course_id);
    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      timeout: 60000,
      beforeSend: function (xhr, settings) {
        self.request_pool.add(xhr);
      }
    });

    request.done(function(data) {
      self.bindData(data);
    });

    request.fail(function(xhr, textStatus, message) {
      if (textStatus == 'abort') {
        return;
      }
      new Kadenze.Notice.error({ message: Kadenze.I18n.t('notice.unexpected_error') });
      console.warn('Error retrieving sheet data:', xhr);
    });

    return request;
  };

  self.bindData = function(data) {
    var mapped_averages = ko.mapping.fromJS(data.averages);
    self.averages(mapped_averages());

    var mapped_courseworks = ko.mapping.fromJS(data.courseworks);
    self.courseworks(mapped_courseworks());
    self.coursework_ids = _.map(data.courseworks, function (coursework) { return coursework.id; });

    _.each(_.initial(self.averages(), 2), function (avg) {
      self.createRingChart('.js-donut-' + avg.key().replace('_','-'), avg.percentage());
    });

    if (self.coursework_ids.length > 0) {
      self.mp = new Mprogress({
        template: 1,
        start: true,
        parent: '#' + self.$el.attr('id') + ' .gradesheet-table'
      });

      _.each(self.coursework_ids, function(coursework_id) {
        self.getCoursework(coursework_id);
      });

      self.hidePlaceholder();
    } else {
      self.showPlaceholder('no_results');
    }
  };

  self.getCoursework = function(coursework_id) {
    var url = Kadenze.Routes.show_course_gradebook_analytics_path(self.course_id, 'coursework', coursework_id);

    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      data: null,
      timeout: 60000,
      beforeSend: function (xhr, settings) {
        self.request_pool.add(xhr);
      }
    });

    request.done(function(data) {
      self.coursework_stats.push(data);

      var completion = self.coursework_stats().length / self.coursework_ids.length;
      self.mp.set(completion);
      if (completion == 1) {
        self.mp.end();
      }
    });

    request.fail(function(xhr, textStatus, message) {
      if (textStatus == 'abort') {
        return;
      }
      console.log('Error retrieving row data:', xhr);
    });
  };

  self.getStat = function (coursework_id, stat) {
    var cw_stat = _.find(self.coursework_stats(), function (coursework) {
      return coursework.overviewable_id == coursework_id;
    });
    return _.isEmpty(cw_stat) ? '' : ko.observable(cw_stat[stat]).extend({numberToPercentage: 2});
  };

  self.exportTable = function () {
    var url = Kadenze.Routes.export_course_gradebook_analytics_path(self.course_id);
    window.open(url, '_blank');
    Kadenze.Analytics.track('grade', 'download', {type: 'global_analytics'});
  };

  self.updatedAtText = ko.computed(function() {
    return (self.coursework_stats().length > 0) ? Kadenze.I18n.t('course.gradebook.last_updated_at') + ' ' + moment(self.coursework_stats()[0].updated_at).fromNow() : '';
  });

  self.refreshAnalytics = function () {
    if (self.analyticsRefreshed() || (self.coursework_stats().length > 0) && (moment(new Date()).diff(self.coursework_stats()[0].updated_at, 'minutes') < 5)) {
      new Kadenze.Notice.info({ message: 'Script to refresh the analytics was just triggered. Please wait a few minutes before running it again.' });
    } else {
      GradebookServices.refreshAnalytics(self.course_id);
      self.analyticsRefreshed(true);
    }
  };

  const __construct = function(that) {
    console.log('constructor called for Kadenze.InstructorGradebook.AnalyticsViewModel');
    that.course_id = $('#course_id').val();
    that.showPlaceholder('loading');
    that.getSheet();
  }(this);
});

